import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Megaphone, Pin } from "lucide-react";
import KrakenLoader from "@/components/KrakenLoader";

const HOUR = 60 * 60 * 1000;

export default function Announcements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/announcements")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="ann-page">
      <div className="eyebrow mb-1">Announcements</div>
      <h1 className="font-display text-2xl sm:text-3xl uppercase mb-5 sm:mb-6">Latest Updates</h1>
      {loading ? (
        <KrakenLoader label="Loading announcements…" testId="ann-loader" />
      ) : (
        <div className="space-y-3">
          {items.length === 0 ? (
            <div className="kr-card rounded-xl p-8 sm:p-10 text-center" data-testid="ann-empty">
              <div className="font-display text-xl sm:text-2xl uppercase text-[#00E5FF]">No announcements yet</div>
              <p className="text-slate-400 mt-2 text-sm">When your coaches post updates, they'll appear here.</p>
            </div>
          ) : items.map((a, i) => {
            const created = a.created_at ? new Date(a.created_at).getTime() : 0;
            const isRecent = created && (Date.now() - created) < 24 * HOUR;
            return (
              <div
                key={a.id}
                className={`kr-card rounded-xl p-4 sm:p-5 ann-fade-in ${isRecent ? "ann-new-flash" : ""}`}
                style={{ animationDelay: `${i * 70}ms` }}
                data-testid={`ann-${a.id}`}
              >
                <div className="flex items-center gap-2 mb-1">
                  {a.pinned ? <Pin size={14} className="text-[#00E5FF]" /> : <Megaphone size={14} className="text-slate-400" />}
                  <span className="text-[10px] uppercase tracking-widest text-slate-400">{a.audience}</span>
                  {isRecent && (
                    <span className="text-[10px] uppercase tracking-widest text-[#00E5FF] bg-[#00E5FF]/10 border border-[#00E5FF]/40 rounded-full px-2 py-0.5" data-testid={`ann-new-${a.id}`}>
                      New
                    </span>
                  )}
                </div>
                <div className="font-display text-lg sm:text-xl uppercase break-words">{a.title}</div>
                <p className="text-slate-300 mt-2 whitespace-pre-wrap break-words">{a.body}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
